import api from '../../../App/socket';

const getLeadsAffiliate = (where, limit, offset) => (
    api.send({
        api: 'db',
        model: 'Lead_affiliate',
        action: 'Read',
        options: {
            attributes: 'all',
            limit,
            offset,
            where,
        },
    }).then(response => response).catch(error => error)
);

const countAffiliates = where => (
    api.send({
        api: 'db',
        model: 'Lead_affiliate',
        action: 'Count',
        options: {
            where,
        },
    }).then(response => response.options.amount).catch(error => error)
);

export { getLeadsAffiliate, countAffiliates };



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/requests/get_leads_affiliate_request.js